import React, { useEffect, useState } from "react";
import "./index.scss";
import reali1 from "../../assets/r1.jpg";
import reali2 from "../../assets/r2.jpg";
import reali3 from "../../assets/r3.jpg";
import AppButton from "../appButton";
import RealisationService from "../../services/realisation/realisation.service";
import { showErrorToaster } from "../toaster/error";
import { useNavigate } from "react-router-dom";

const realisationService = new RealisationService();

const ActualitesHome = () => {
  const [realisation, setRealisation] = useState([]);
  const navigate = useNavigate();

  const handleCardClick = (id) => {
    navigate(`/realisation/${id}`); // Navigue vers la page de la liste avec l'ID en paramètre
  };

  const loadData = async () => {
    try {
      const res = await realisationService?.getAllActiveRealisation();
      setRealisation(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const imageListe = [reali1, reali2, reali3]; // Tableau des images
  const limitedRealisations = realisation.slice(0, 3);
  return (
    <section className="section-container">
      {/* Div en haut avec les titres */}
      <div className="top-content">
        <div>
          <h3 className="small-title">JM Foundation</h3>
          <h1 className="big-title">Actualités & Réalisations</h1>
        </div>
        <div>
          <p className="text-title">
            Découvrez le pouvoir transformateur de l'Afrique à travers une
            collection captivante d'audiovisuels présentant diverses initiatives
          </p>
        </div>
      </div>

      {/* Div en bas avec les images */}
      <div className="bottom-content">
        {limitedRealisations.length > 0 && (
          <>
            <div
              className="left-column"
              onClick={() => handleCardClick(limitedRealisations[0]?.id)}
            >
              <div className="text-on-image">
                <h2>{limitedRealisations[0]?.title}</h2>
                <p>{limitedRealisations[0]?.date}</p>
              </div>
              <img
                className="big-image"
                src={imageListe[0]} // Associer une image
                alt={limitedRealisations[0]?.alt || "Illustration"}
              />
            </div>
            <div className="right-column">
              {/* Liste des autres images */}
              {limitedRealisations.slice(1).map((image, index) => (
                <div
                  key={image.id}
                  className="small_image_content"
                  onClick={() => handleCardClick(image.id)}
                >
                  <img
                    className="small-image"
                    src={imageListe[(index + 1) % imageListe.length]} // Associer les images suivantes
                    alt={image.alt || "Illustration"}
                  />
                  <div className="text_small-image">
                    <h3 className="title">{image.title}</h3>
                    <p className="date">{image.date}</p>
                  </div>
                </div>
              ))}
              <div
                className=" card-image-rea small_image_content"
                onClick={() => handleCardClick(1000)}
              >
                <div className="text_small-image">
                  <h3 className="title">
                    Soutien aux communautés durant les crises
                  </h3>
                  <p className="date">01/09/2023</p>
                  <p className="descr-rea">
                    {" "}
                    Lors de crises humanitaires, telles que les conflits armés
                    ou les catastrophes naturelles, la fondation a été présente
                    pour apporter un soutien immédiat. Que ce soit par l’envoi
                    de secours d’urgence ou la mise en place{" "}
                    <span
                      className="span-btn"
                      onClick={() => handleCardClick(1000)}
                    >
                      Voir Plus
                    </span>
                  </p>
                </div>
              </div>
              <div
                className=" card-image-rea small_image_content"
                onClick={() => handleCardClick(1001)}
              >
                <div className="text_small-image">
                  <h3 className="title">
                    Développement d’infrastructures locales
                  </h3>
                  <p className="date">01/09/2023</p>
                  <p className="descr-rea">
                    Au-delà des forages, la fondation investit dans
                    l’amélioration des infrastructures locales, telles que la
                    construction de ponts, de routes ou de structures
                    sanitaires. Ces projets..
                    <span
                      className="span-btn"
                      onClick={() => handleCardClick(1001)}
                    >
                      Voir Plus
                    </span>{" "}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div className="button-container">
        <div className="btn_div">
          <AppButton
            text="Voir Plus"
            className="width-total"
            color="orange"
            size="large"
            onClick={() => {
              navigate("/realisation");
              window.scrollTo(0, 0);
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ActualitesHome;
